module.exports = __webpack_public_path__ + "static/img/clickin522.d5e94982.png";